import { INotificationPermits } from 'modules/settings/models';
import API from 'services/api';

export const getNotificationPermits = ({
  onlyRepresentativeObjects,
}: {
  onlyRepresentativeObjects: string;
}): Promise<INotificationPermits[]> =>
  API.get('/api/notifications/permits', { params: { onlyRepresentativeObjects } })?.then(
    response => response?.data,
  );
